import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import BusinessUnitCreateUpdateScreen from "../business_unit/business_unit_create_update";
import BusinessUnitListScreen from "../business_unit/business_unit_list";
import DepartmentCreateUpdateScreen from "../department/department_create_update";
import DepartmentListScreen from "../department/department_list";
import BudgetCadenceScreen from "../budget_cadence/budget_cadence_screen";

const org_routes: RouteParam[] = [
  // Business Unit
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.business_unit,
    component: BusinessUnitListScreen,
    module: MODULE.business_unit,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.business_unit + "/create",
    component: BusinessUnitCreateUpdateScreen,
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.business_unit + "/update/:id",
    component: BusinessUnitCreateUpdateScreen,
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },

  // Department
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.department,
    component: DepartmentListScreen,
    module: MODULE.department,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.department + "/create",
    component: DepartmentCreateUpdateScreen,
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.department + "/update/:id",
    component: DepartmentCreateUpdateScreen,
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },

  // Phase 7C — Budget Cadence bulk-edit (EAF only).
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.budget_cadence,
    component: BudgetCadenceScreen,
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default org_routes;
